import { GoogleReCaptchaProvider } from "react-google-recaptcha-v3";
import { MainLayout } from "@/layouts";
import { MainFreeTrial, SignUp } from "@/pagePartials/freeTrial";
import { Stepsv2 } from "@/pagePartials/freeTrial/steps/Stepsv2";

const FreeTrial = () => {
  return (
    <GoogleReCaptchaProvider
      reCaptchaKey="6Le_NVQiAAAAAICg36Gi-LIbY9IbaXORJl0eVCop"
      scriptProps={{
        async: false,
        defer: false,
        appendTo: "head",
        nonce: undefined,
      }}
    >
      <MainLayout
        bgTheme="#fafafa"
        navbarTheme="light"
        title="Free Trial"
        description="Free Trial is a page where the client can contact an advisor to know about the product/services"
      >
        <MainFreeTrial />
        <Stepsv2 />
        <SignUp />
      </MainLayout>
    </GoogleReCaptchaProvider>
  );
};

export default FreeTrial;
